import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

// Global event channel for behaviors to communicate with host application
@Injectable({
  providedIn: 'root',
})
export class BehaviorEventChannel {
  private _eventChannel = new Subject<any>();

  on(eventName: string) {
    return this._eventChannel.pipe(filter(v => v.eventName === eventName));
  }

  emit(eventName: string, data?: any) {
    this._eventChannel.next({ eventName, data });
  }
}
